import TextCell from 'components/TextCell';
import type { ManagedTeamsType } from '../..';

interface CellProps {
  rowData: ManagedTeamsType;
}

export default function OemSegmentNameCell({
  rowData: { oemSegment },
}: CellProps) {
  return <TextCell text={oemSegment?.name} />;
}
